// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__krXp1","badge--error":"styles_badge--error__ZOymK","badge--success":"styles_badge--success__zjUIu"};